export * from '@primeuix/themes/material/imagecompare';
export { default } from '@primeuix/themes/material/imagecompare';
